import { actionTypes } from '../constants/actionTypes';
import { authCode } from '../initializeObjects/authCode';

export const pairCode = (state = authCode, action) => {
  switch (action.type) {
    case actionTypes.PAIR_CODE:
      return Object.assign({}, state, action.payload);
  }
  return state;
};

export const mobileDevices = (state = [], action) => {
  switch (action.type) {
    case actionTypes.MOBILE_DEVICES:
      return [].concat(action.payload);
  }
  return state;
};